import { SxProps } from "@mui/material";

export const sxMenuItem: SxProps = {
    fontFamily: 'Unimed-Sans',
    color: 'GrayText',
    marginBottom: '2px'
}